export default {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 20px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 10,
    paddingBottom: 10,
  },
  link: {
    marginTop: 10,
    marginBottom: 10,
    paddingLeft: 0,
  },
  tag: {
    marginTop: 12,
    borderRadius: 4,
    padding: 6,
    color: 'white',
    display: 'table',
  },
  spacer: {
    marginTop: 30,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
};



// WEBPACK FOOTER //
// ./src/styles/TBenefits.js